import React from 'react'
import { View, ViewStyle, TextStyle } from 'react-native'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { Header, color, Text, iconArrowBack, Screen } from '@trivie/ui-mobile'
import { useStores } from '@trivie/core'
import { ScrollView } from 'react-native-gesture-handler'
import { useHistory } from 'react-router-dom'

export const GDPRPolicyScreen = observer((props: any) => {
  const { userStore } = useStores()
  const { user } = userStore

  const history = useHistory()
  const goBack = () => history.goBack()

  const { t } = useTranslation()

  if (!user) {
    return null
  }

  return (
    <View style={FULL}>
      <View style={CONTAINER}>
        <div style={HEADER_STICKY_CONTAINER}>
          <div style={HEADER_FLEX_CONTAINER}>
            <Header leftIcon={iconArrowBack} onLeftPress={goBack} center headerTx="Settings.gdpr" />
          </div>
        </div>

        <ScrollView contentContainerStyle={{ paddingHorizontal: 20, paddingBottom: 32 }}>
          <Text
            style={{ textAlign: 'left', color: '#212121' }}
            variant="body1"
            text={`When you use Trivie products and services, we may collect certain non-personally identifiable information for purposes including improving our products and services, troubleshooting bugs, providing services to you, facilitating the provision of software updates, dynamically served content and product support as well as communicating with you. The non-personal information collected may include information about your computer, hardware, software, platform, game system, media, mobile device, and incident data, for example. We also collect other non-personal information such as username, user ID or persona, feature usage, game play statistics, scores and achievements, user rankings and click paths as well as other data that you may provide in surveys, and your account preferences.

If you are a resident of the European Economic Area (EEA), you have certain data protection rights, and we employ commercially reasonable steps to allow you to correct, amend, delete, or limit the use of your personal data at any time. If you wish to be informed what personal data we hold about you, and if you want it to be removed from our systems, please contact us privacy@trivie.com‍
              
In certain circumstances, you have the following data protection rights:‍
              
The right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete.‍
              
The right to object. You have the right to object to our processing of your personal data.‍
              
The right of restriction. You have the right to request that we restrict the processing of your personal information.‍
              
The right to data portability. You have the right to be provided with a copy of the information we have on you in a structured, machine-readable and commonly used format.‍
              
The right to withdraw consent. You also have the right to withdraw your consent at any time where Trivie, Inc. relied on your consent to process your personal information.
              
Please note that we may ask you to verify your identity before responding to such requests.‍
              
You have the right to complain to a Data Protection Authority about our collection and use of your personal data. For more information, please contact your local data protection authority in the European Economic Area (EEA).
              
Whenever made possible, you can access, update or request deletion of your personal data directly within the Help section of the Registered Website. If you are unable to perform these actions yourself, please contact us at privacy@trivie.com to assist you.
              
Data Security and Integrity Contact Information
We use various safeguards to protect the personal information submitted to us, both during transmission and once we receive it. However, no method of transmission over the Internet or via mobile device, or method of electronic storage, is 100% secure. Therefore, while we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
              
Trivie uses personal information supplied by or on behalf of Registered Users solely to facilitate use of the Services by said users and, where relevant, their managers or administrators. Trivie will take reasonable steps to verify the validity of personal information supplied, for example by validating email addresses and/or the source of data supplied.
              
U.S. Government Agency Governing Authority
Trivie, Inc. is subject to the investigatory and enforcement powers of the Federal Trade Commission.
              
Contact Information
If you have any questions about this Privacy Policy or our treatment of the information you provide us, please write to us by email at privacy@trivie.com or by mail to Trivie, Inc., PO Box 12801, Dallas, Texas USA, Attn: Privacy.
              
We periodically update this Privacy Policy, and we may update this Privacy Policy from time to time by posting a new version online. Your continued use of the Website, the Services, and/or continued provision of personal data to us will be subject to the terms of the then-current Privacy Policy.`}
          />
        </ScrollView>
      </View>
    </View>
  )
})

/**
 * Styling
 */
const FULL: ViewStyle = { flex: 1 }
const CONTAINER: ViewStyle = {
  paddingTop: 40,
  paddingRight: 40,
  paddingLeft: 40,
  backgroundColor: color.white,
}
const HEADER_STICKY_CONTAINER: React.CSSProperties = {
  position: 'sticky',
  top: 0,
  width: '100%',
  zIndex: 99,
  backgroundColor: 'white',
}
const HEADER_FLEX_CONTAINER: React.CSSProperties = {
  display: 'flex',
  maxWidth: '1440px',
  paddingBottom: 10,
  justifyContent: 'space-between',
}
